export default __webpack_public_path__ + "static/media/ecom1.c488289a.png";